import {useTranslation} from "react-i18next";
import {PageTemplate} from "../../../shared/layout/PageTemplate";
import {CommissionerList} from "./components/CommissionerList";

export const Commissioner = () => {
    const {t} = useTranslation()
    return <PageTemplate pageName={`${t('side_bar.crud')}`} title={`${t('side_bar.commissioner')}`}
                         content={<CommissionerList/>}/>
}